import React from "react";
import { useLocation } from "react-router-dom";
import { IMAGES, BRAND } from "../../lib/brand";
import { LogIn, ArrowLeft, ShieldAlert } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const Login = () => {
  const location = useLocation();
  const denied = location.state?.denied;

  const signIn = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a] grain relative grid place-items-center px-4">
      <div className="relative z-10 w-full max-w-md border-2 border-[#7CB518] bg-[#0d0d0d] p-8 hard-shadow">
        <img src={IMAGES.logo} alt={BRAND.name} className="h-20 w-20 object-contain mx-auto" />
        <h1 className="font-display uppercase text-3xl text-center mt-4 text-white">Owner Login</h1>
        <p className="text-center text-sm text-white/50 mt-2">Private dashboard — {BRAND.name}</p>

        {denied && (
          <div className="mt-5 border-2 border-red-500 bg-red-500/10 p-3 flex items-start gap-2 text-sm text-red-300" data-testid="access-denied">
            <ShieldAlert size={18} className="shrink-0 mt-0.5" />
            <span>That Google account isn't authorized for the owner dashboard.</span>
          </div>
        )}

        <button
          data-testid="google-signin-btn"
          onClick={signIn}
          className="press w-full mt-6 bg-[#7CB518] text-black font-display uppercase text-lg py-4 border-2 border-[#7CB518] hard-shadow-white flex items-center justify-center gap-2"
        >
          <LogIn size={20} /> Sign in with Google
        </button>

        <a href="/" className="mt-6 flex items-center justify-center gap-2 text-xs uppercase tracking-[0.2em] text-white/50 hover:text-[#7CB518]">
          <ArrowLeft size={14} /> Back to site
        </a>
      </div>
    </div>
  );
};
